/* VAEN — Product page sections (dependency-free, idempotent) */
(function () {
  if (window.__vnpLoaded) return; window.__vnpLoaded = true;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function once(el, k) { if (el.dataset[k]) return false; el.dataset[k] = '1'; return true; }
  function inView(el, cb, opts) {
    if (!('IntersectionObserver' in window) || reduce) { cb(); return; }
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { cb(); io.disconnect(); } }); }, opts || { threshold: 0.25 });
    io.observe(el);
  }
  function selectedOptions() {
    return $$('variant-selects input[type="radio"]:checked, variant-selects select').map(function (i) { return (i.value || '').toLowerCase(); });
  }
  function onVariant(cb) {
    document.addEventListener('change', function (e) { if (e.target.closest && e.target.closest('variant-selects')) setTimeout(cb, 0); });
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.variantChange, function () { setTimeout(cb, 30); });
  }

  /* ---------- header offset (sticky header aware) ---------- */
  var offset = 0;
  function measureOffset() {
    var max = 0;
    $$('.section-header, .shopify-section-group-header-group, .shopify-section-group-header-group > *, sticky-header, [id*="shopify-section"][id*="header"], .header-wrapper').forEach(function (el) {
      var cs = getComputedStyle(el);
      if (cs.position !== 'fixed' && cs.position !== 'sticky') return;
      var r = el.getBoundingClientRect();
      if (r.top <= 2 && r.bottom > 0 && r.height < window.innerHeight / 2 && cs.visibility !== 'hidden' && cs.opacity !== '0') max = Math.max(max, r.bottom);
    });
    offset = Math.round(max);
    document.documentElement.style.setProperty('--vnp-offset', (offset + 72) + 'px');
    return offset;
  }

  /* ---------- sticky nav ---------- */
  function initNav() {
    var nav = $('[data-vnp-nav]'); if (!nav || !once(nav, 'vnpNav')) return;
    if (nav.parentElement !== document.body) document.body.appendChild(nav); /* escape transformed parents */
    var links = $('[data-vnp-links]', nav);
    var main0 = $('[id^="ProductInfo-"]');
    var anchors = $$('[data-pdp-anchor]').filter(function (a) { return (a.dataset.label || '').trim() && a.getClientRects().length; });
    var rev = $('.shopify-section[id*="judgeme"], .shopify-section[id*="review"], #judgeme_product_reviews, .jdgm-review-widget');
    if (rev && nav.dataset.reviewsLabel) {
      var sec = rev.closest('.shopify-section') || rev;
      if (!sec.id) sec.id = 'vnp-reviews';
      sec.classList.add('vnp-reviews-anchor'); sec.dataset.label = nav.dataset.reviewsLabel;
      if (anchors.indexOf(sec) < 0 && !sec.contains(main0) && !(main0 && main0.contains(sec))) anchors.push(sec);
    }
    anchors.sort(function (a, b) { return a.compareDocumentPosition(b) & 4 ? -1 : 1; });
    anchors.forEach(function (a) {
      var l = document.createElement('a'); l.href = '#' + a.id; l.textContent = a.dataset.label; l.dataset.target = a.id;
      l.addEventListener('click', function (e) { e.preventDefault(); var y = a.getBoundingClientRect().top + window.scrollY - (measureOffset() + nav.offsetHeight) + 1; window.scrollTo({ top: y, behavior: reduce ? 'auto' : 'smooth' }); });
      links.appendChild(l);
    });
    $('[data-vnp-top]', nav).addEventListener('click', function (e) { e.preventDefault(); window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' }); });
    var main = $('[id^="ProductInfo-"]'); main = main ? (main.closest('.shopify-section') || main) : null;
    var ticking = false;
    function update() {
      ticking = false;
      var off = measureOffset();
      nav.style.top = off + 'px';
      var show = main ? main.getBoundingClientRect().bottom < off + 40 : window.scrollY > 900;
      nav.classList.toggle('is-on', show);
      var line = off + nav.offsetHeight + 40, current = null;
      anchors.forEach(function (a) { if (a.getBoundingClientRect().top <= line) current = a.id; });
      $$('a', links).forEach(function (l) {
        var on = l.dataset.target === current; l.classList.toggle('is-active', on);
        if (on && current && links.scrollWidth > links.clientWidth) { var lr = l.getBoundingClientRect(), cr = links.getBoundingClientRect(); if (lr.left < cr.left) links.scrollLeft += lr.left - cr.left - 8; else if (lr.right > cr.right) links.scrollLeft += lr.right - cr.right + 8; }
      });
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    window.addEventListener('resize', update);
    update();
    var priceEl = $('[data-vnp-price]', nav);
    onVariant(function () { var p = $('[id^="price-"] .vaen-price__current') || $('[id^="price-"] .price-item--sale, [id^="price-"] .price-item--regular'); if (p && priceEl) priceEl.textContent = p.textContent.trim(); });
  }

  /* ---------- will it fit ---------- */
  function parseSize(v) {
    var nums = (v.match(/\d+(?:[.,]\d+)?/g) || []).map(function (n) { return parseFloat(n.replace(',', '.')); });
    var inch = /(\bin\b|inch|")/i.test(v) && !/cm/i.test(v);
    var f = inch ? 2.54 : 1;
    if (nums.length >= 3) return { L: nums[0] * f, D: nums[1] * f, H: nums[2] * f };
    if (nums.length === 2) return { L: nums[0] * f, D: nums[0] * f, H: nums[1] * f, single: true };
    return null;
  }
  function seatMax(s) { var m = String(s || '').match(/\d+/g); return m ? Math.max.apply(null, m.map(Number)) : 0; }
  function initDim(root) {
    if (!once(root, 'vnpDim')) return;
    var sizes; try { sizes = JSON.parse($('[data-vnp-dim-sizes]', root).textContent); } catch (e) { return; }
    sizes = sizes.map(function (s) { s.dim = parseSize(s.value); return s; }).filter(function (s) { return s.dim; });
    var sec = root.closest('.vnp-dim');
    if (!sizes.length) { if (sec) sec.closest('.shopify-section').style.display = 'none'; return; }
    var shape = root.dataset.shape, dining = root.dataset.dining === 'true', clr = parseFloat(root.dataset.clearance) || 90;
    if (shape !== 'round' && sizes.every(function (s) { return s.dim.single; })) shape = 'round';
    var unit = 'cm', current = sizes.find(function (s) { return s.value === root.dataset.current; }) || sizes[0];
    var maxL = Math.max.apply(null, sizes.map(function (s) { return s.dim.L; }));
    var maxD = Math.max.apply(null, sizes.map(function (s) { return s.dim.D; }));
    var maxH = Math.max.apply(null, sizes.map(function (s) { return s.dim.H; }));
    var pad = dining ? clr : 20;
    var W = 680, sc = Math.min((W - 80) / (maxL + 2 * pad), 340 / (maxD + 2 * pad));
    var planH = (maxD + 2 * pad) * sc + 70, elevH = maxH * sc + 50, H = planH + elevH;
    var plan = $('[data-vnp-plan]', root), chips = $('[data-vnp-chips]', root);
    function fmt(cm, withUnit) { var v = unit === 'cm' ? Math.round(cm) : (cm / 2.54).toFixed(1).replace(/\.0$/, ''); return withUnit ? v + (unit === 'cm' ? ' cm' : '"') : v; }
    function draw() {
      var d = current.dim, L = d.L * sc, D = d.D * sc, cx = W / 2, cy = planH / 2 + 10, g = [];
      var x0 = cx - L / 2, y0 = cy - D / 2;
      if (dining) { var rw = (d.L + 2 * clr) * sc, rh = (d.D + 2 * clr) * sc; g.push('<rect class="room" x="' + (cx - rw / 2) + '" y="' + (cy - rh / 2) + '" width="' + rw + '" height="' + rh + '" rx="' + (shape === 'round' ? rw / 2 : 6) + '"/>'); }
      var n = dining ? (seatMax(current.seating) || Math.max(2, Math.round(d.L / 60) * 2)) : 0;
      var cw = 46 * sc, ch = 42 * sc, gap = 8 * sc;
      if (n) {
        if (shape === 'round') {
          for (var k = 0; k < n; k++) { var a = (k / n) * Math.PI * 2 - Math.PI / 2, r = L / 2 + gap + ch / 2; var px = cx + Math.cos(a) * r, py = cy + Math.sin(a) * r; g.push('<rect class="chair" x="' + (px - cw / 2) + '" y="' + (py - ch / 2) + '" width="' + cw + '" height="' + ch + '" rx="' + 6 * sc + '" transform="rotate(' + (a * 180 / Math.PI + 90) + ' ' + px + ' ' + py + ')"/>'); }
        } else {
          var ends = n >= 6 ? 2 : 0, top = Math.ceil((n - ends) / 2), bot = n - ends - top;
          var inset = shape === 'oval' ? D * 0.35 : 0, usable = L - 2 * inset;
          [[top, y0 - gap - ch], [bot, y0 + D + gap]].forEach(function (row) { for (var i = 0; i < row[0]; i++) { var px = x0 + inset + usable * (i + 0.5) / row[0] - cw / 2; g.push('<rect class="chair" x="' + px + '" y="' + row[1] + '" width="' + cw + '" height="' + ch + '" rx="' + 6 * sc + '"/>'); } });
          if (ends) { g.push('<rect class="chair" x="' + (x0 - gap - ch) + '" y="' + (cy - cw / 2) + '" width="' + ch + '" height="' + cw + '" rx="' + 6 * sc + '"/>'); g.push('<rect class="chair" x="' + (x0 + L + gap) + '" y="' + (cy - cw / 2) + '" width="' + ch + '" height="' + cw + '" rx="' + 6 * sc + '"/>'); }
        }
      }
      if (shape === 'round') g.push('<ellipse class="tbl" cx="' + cx + '" cy="' + cy + '" rx="' + L / 2 + '" ry="' + D / 2 + '"/>');
      else g.push('<rect class="tbl" x="' + x0 + '" y="' + y0 + '" width="' + L + '" height="' + D + '" rx="' + (shape === 'oval' ? D / 2 : 3) + '"/>');
      var ly = (dining ? cy - (d.D / 2 + clr) * sc : y0) - 18, lx = (dining ? cx + (d.L / 2 + clr) * sc : x0 + L) + 18;
      g.push('<line class="dl" x1="' + x0 + '" y1="' + ly + '" x2="' + (x0 + L) + '" y2="' + ly + '"/><line class="dl" x1="' + x0 + '" y1="' + (ly - 5) + '" x2="' + x0 + '" y2="' + (ly + 5) + '"/><line class="dl" x1="' + (x0 + L) + '" y1="' + (ly - 5) + '" x2="' + (x0 + L) + '" y2="' + (ly + 5) + '"/>');
      g.push('<text class="dt" x="' + cx + '" y="' + (ly - 9) + '" text-anchor="middle">L ' + fmt(d.L, true) + '</text>');
      if (lx > W - 4) lx = W - 4;
      g.push('<line class="dl" x1="' + lx + '" y1="' + y0 + '" x2="' + lx + '" y2="' + (y0 + D) + '"/><line class="dl" x1="' + (lx - 5) + '" y1="' + y0 + '" x2="' + (lx + 5) + '" y2="' + y0 + '"/><line class="dl" x1="' + (lx - 5) + '" y1="' + (y0 + D) + '" x2="' + (lx + 5) + '" y2="' + (y0 + D) + '"/>');
      g.push('<text class="dt" x="' + (lx - 8) + '" y="' + (cy + 4) + '" text-anchor="end" transform="rotate(-90 ' + (lx - 8) + ' ' + cy + ')">D ' + fmt(d.D, true) + '</text>');
      /* elevation */
      var fy = planH + elevH - 20, Hh = d.H * sc, top2 = fy - Hh, th = Math.max(3, 4 * sc);
      g.push('<line class="floor" x1="20" y1="' + fy + '" x2="' + (W - 20) + '" y2="' + fy + '"/>');
      g.push('<rect class="elev" x="' + x0 + '" y="' + top2 + '" width="' + L + '" height="' + th + '" rx="1"/>');
      if (shape === 'round') { var bw = Math.max(6, L * 0.32); g.push('<rect class="elev" x="' + (cx - bw / 2) + '" y="' + (top2 + th) + '" width="' + bw + '" height="' + (Hh - th) + '"/>'); }
      else { var lw = Math.max(5, L * 0.07), li = L * 0.16; g.push('<rect class="elev" x="' + (x0 + li) + '" y="' + (top2 + th) + '" width="' + lw + '" height="' + (Hh - th) + '"/><rect class="elev" x="' + (x0 + L - li - lw) + '" y="' + (top2 + th) + '" width="' + lw + '" height="' + (Hh - th) + '"/>'); }
      var hx = Math.min(x0 + L + 22, W - 6);
      g.push('<line class="dl" x1="' + hx + '" y1="' + top2 + '" x2="' + hx + '" y2="' + fy + '"/><text class="dt" x="' + (hx - 8) + '" y="' + (top2 + Hh / 2) + '" text-anchor="end" transform="rotate(-90 ' + (hx - 8) + ' ' + (top2 + Hh / 2) + ')">H ' + fmt(d.H, true) + '</text>');
      g.push('<text class="dt" x="20" y="' + (planH + 14) + '">ELEVATION</text><text class="dt" x="20" y="14">PLAN</text>');
      plan.innerHTML = '<svg viewBox="0 0 ' + W + ' ' + H + '" role="img" aria-label="' + current.value + '">' + g.join('') + '</svg>';
      $('[data-vnp-l]', root).innerHTML = fmt(d.L) + '<small>' + unit + '</small>';
      $('[data-vnp-d]', root).innerHTML = fmt(d.D) + '<small>' + unit + '</small>';
      $('[data-vnp-h]', root).innerHTML = fmt(d.H) + '<small>' + unit + '</small>';
      var sw = $('[data-vnp-seat-wrap]', root);
      if (sw) { sw.hidden = !current.seating; $('[data-vnp-seat]', root).textContent = current.seating ? current.seating + ' people' : ''; }
      var rm = $('[data-vnp-room]', root);
      if (rm) rm.textContent = fmt(d.L + 2 * clr) + ' × ' + fmt(d.D + 2 * clr, true);
      $$('button', chips).forEach(function (b) { b.classList.toggle('is-active', b.dataset.value === current.value); b.setAttribute('aria-pressed', b.dataset.value === current.value); });
    }
    sizes.forEach(function (s) {
      var b = document.createElement('button'); b.type = 'button'; b.dataset.value = s.value; b.textContent = s.value;
      b.addEventListener('click', function () {
        current = s; draw();
        var radio = $$('variant-selects input[type="radio"]').find(function (r) { return r.value === s.value; });
        if (radio && !radio.checked) radio.click();
      });
      chips.appendChild(b);
    });
    $$('[data-vnp-unit]', root).forEach(function (b) { b.addEventListener('click', function () { unit = b.dataset.vnpUnit; $$('[data-vnp-unit]', root).forEach(function (x) { x.classList.toggle('is-active', x === b); }); draw(); }); });
    onVariant(function () { var sel = selectedOptions(); var m = sizes.find(function (s) { return sel.indexOf(s.value.toLowerCase()) > -1; }); if (m && m !== current) { current = m; draw(); } });
    draw();
  }

  /* ---------- order to door ---------- */
  function addBiz(d, n) { var x = new Date(d); while (n > 0) { x.setDate(x.getDate() + 1); var w = x.getDay(); if (w !== 0 && w !== 6) n--; } return x; }
  function initJourney(sec) {
    if (!once(sec, 'vnpJour')) return;
    var eta = $('[data-vnp-eta]', sec), steps = $('[data-vnp-steps]', sec);
    var min = parseInt(eta.dataset.min, 10) || 20, max = parseInt(eta.dataset.max, 10) || 25;
    var now = new Date(), f = new Intl.DateTimeFormat('en-CA', { month: 'short', day: 'numeric' });
    var a = addBiz(now, min), b = addBiz(now, max);
    var range = a.getMonth() === b.getMonth() ? f.format(a) + '–' + b.getDate() : f.format(a) + ' – ' + f.format(b);
    $('[data-vnp-eta-v]', eta).textContent = range;
    $$('[data-vnp-when]', sec).forEach(function (el) {
      var w = el.dataset.vnpWhen;
      if (w === 'today') el.textContent = 'Today · ' + f.format(now);
      else if (w === 'start') el.textContent = 'From ' + f.format(addBiz(now, 1));
      else if (w === 'ready') el.textContent = 'Est. ' + range;
    });
    if (steps) { steps.style.setProperty('--cols', steps.children.length); inView(steps, function () { steps.style.setProperty('--prog', '100%'); }); }
  }

  /* ---------- anatomy stack ---------- */
  function initStack(el) { if (!once(el, 'vnpStack')) return; inView(el, function () { setTimeout(function () { el.classList.add('is-open'); }, 250); }, { threshold: 0.5 }); }

  /* ---------- finish samples ---------- */
  function money(cents, fmt) {
    var v = (cents / 100), two = v.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','), none = Math.round(v).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (fmt || '${{amount}}').replace(/\{\{\s*amount_no_decimals\s*\}\}/, none).replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, two.replace('.', ',')).replace(/\{\{\s*amount\s*\}\}/, two);
  }
  function initSamples(root) {
    if (!once(root, 'vnpSamp')) return;
    var btn = $('[data-vnp-add]', root), total = $('[data-vnp-total]', root), err = $('[data-vnp-err]', root), touched = false, fmt = root.dataset.moneyFormat;
    var boxes = $$('input[type="checkbox"]', root);
    function sum() {
      var c = boxes.filter(function (b) { return b.checked; }), cents = c.reduce(function (t, b) { return t + (parseInt(b.dataset.price, 10) || 0); }, 0);
      total.textContent = money(cents, fmt);
      btn.disabled = !c.length;
      btn.querySelector('span').textContent = c.length ? btn.dataset.label + ' · ' + c.length : btn.dataset.empty;
      btn.classList.remove('is-done');
    }
    boxes.forEach(function (b) { b.addEventListener('change', function () { touched = true; sum(); }); });
    onVariant(function () {
      if (touched) return; var sel = selectedOptions();
      $$('.vnp-chip', root).forEach(function (chip) { var t = $('.vnp-chip__t', chip).textContent.trim().toLowerCase(), inp = $('input', chip); var m = sel.some(function (v) { return v === t || v.indexOf(t) > -1; }); chip.classList.toggle('is-match', m); if (!inp.disabled) inp.checked = m; });
      sum();
    });
    btn.addEventListener('click', function () {
      var items = boxes.filter(function (b) { return b.checked; }).map(function (b) { return { id: parseInt(b.value, 10), quantity: 1 }; });
      if (!items.length) return;
      var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      var body = { items: items };
      if (cart && cart.getSectionsToRender) { body.sections = cart.getSectionsToRender().map(function (s) { return s.id; }); body.sections_url = window.location.pathname; }
      btn.disabled = true; err.hidden = true;
      fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { return r.json(); })
        .then(function (j) {
          if (j.status && j.description) { err.textContent = j.description; err.hidden = false; btn.disabled = false; return; }
          btn.querySelector('span').textContent = btn.dataset.added; btn.classList.add('is-done'); btn.disabled = false;
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'vaen-samples', cartData: j });
          if (cart && cart.renderContents && j.sections) { if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty'); cart.renderContents(j); }
          else window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        })
        .catch(function () { err.textContent = 'Something went wrong. Please try again.'; err.hidden = false; btn.disabled = false; });
    });
    sum();
  }

  /* ---------- anatomy profiles ---------- */
  var COLORS = { 'off white': '#ECE8E0', 'ivory': '#E7DECB', 'sand': '#D3C6B0', 'gray': '#A7A39C', 'grey': '#A7A39C', 'black': '#2B2927', 'taupe': '#9C8F80', 'beige': '#D9CCB6', 'white': '#F1EFEA',
    'dark oak': '#4B3526', 'white oak': '#CFB48E', 'natural oak': '#BE9668', 'cherry': '#8A4B2E', 'medium oak': '#9A6E45', 'light oak': '#C9A77D', 'oak': '#B08757', 'natural': '#C6A47A', 'walnut': '#5A3B27', 'ash': '#CDB898', 'teak': '#8E5E36' };
  function surfaceValues() {
    var out = [];
    $$('variant-selects fieldset').forEach(function (fs) {
      var lg = $('legend', fs), n = ((lg && lg.textContent) || '').toLowerCase();
      if (n.indexOf('leg') > -1 || n.indexOf('base') > -1) return;
      var c = $('input[type="radio"]:checked', fs); if (c) out.push(c.value.toLowerCase());
    });
    $$('variant-selects select').forEach(function (sl) { var lb = sl.name.toLowerCase(); if (lb.indexOf('leg') < 0 && lb.indexOf('base') < 0) out.push(sl.value.toLowerCase()); });
    return out;
  }
  function colorFor(vals) {
    var keys = Object.keys(COLORS).sort(function (a, b) { return b.length - a.length; });
    for (var i = 0; i < vals.length; i++) for (var j = 0; j < keys.length; j++) if (vals[i].indexOf(keys[j]) > -1) return { hex: COLORS[keys[j]], name: vals[i] };
    return null;
  }
  function initAnat(sec) {
    if (!once(sec, 'vnpAnat')) return;
    var panels = $$('.vnp-anat__panel', sec);
    function openIso(p) { var iso = $('[data-vnp-iso]', p); if (!iso) return; iso.classList.remove('is-open'); inView(iso, function () { setTimeout(function () { iso.classList.add('is-open'); }, 200); }, { threshold: 0.35 }); if (iso.__seen) setTimeout(function () { iso.classList.add('is-open'); }, 120); iso.__seen = true; }
    function apply() {
      var vals = surfaceValues(), hay = vals.join(' ');
      var pick = null;
      if (hay) panels.some(function (p) { return (p.dataset.keys || '').split(',').some(function (k) { k = k.trim(); if (k && hay.indexOf(k) > -1) { pick = p; return true; } }); });
      pick = pick || $('.vnp-anat__panel.is-active', sec) || panels[0];
      panels.forEach(function (p) { var on = p === pick; if (on !== !p.hidden) { p.hidden = !on; p.classList.toggle('is-active', on); if (on) openIso(p); } });
      var c = colorFor(vals), iso = $('[data-vnp-iso]', pick);
      if (iso) { iso.style.setProperty('--top', c ? c.hex : pick.dataset.defaultColor); var nm = $('[data-vnp-iso-name]', iso); if (nm && c) nm.textContent = c.name; }
    }
    panels.forEach(function (p) { if (!p.hidden) openIso(p); });
    apply(); onVariant(apply);
  }
  function initVs(sec) {
    if (!once(sec, 'vnpVs')) return;
    inView(sec, function () { sec.classList.add('is-in'); }, { threshold: 0.2 });
    $$('[data-vnp-top-link]', sec).forEach(function (a) { a.addEventListener('click', function (e) { e.preventDefault(); window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' }); }); });
    $$('[data-vnp-samples-link]', sec).forEach(function (a) { var t = $('[id^="vnp-samp-"]'); if (!t) { a.remove(); return; } a.addEventListener('click', function (e) { e.preventDefault(); window.scrollTo({ top: t.getBoundingClientRect().top + window.scrollY - (measureOffset() + 70), behavior: reduce ? 'auto' : 'smooth' }); }); });
  }

  function init() {
    $$('[data-vnp-anat]').forEach(initAnat);
    $$('[data-vnp-vs]').forEach(initVs);
    $$('[data-vnp-dim]').forEach(initDim);
    $$('.vnp-jour').forEach(initJourney);
    $$('[data-vnp-samples]').forEach(initSamples);
    initNav();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () { window.__vnpReinit && window.__vnpReinit(); init(); });
})();
